export const USER_PORTAL_URL="https://admin-portal-kc.navaantrix.com/keycloak/";

export const API_AUTH_TOKEN=localStorage.getItem('authToken');

export const REALM="navaantrix";
export const CLIENT_NAME = "plambo";
export const STAGE_CLIENT_NAME = "plambo-stage";